import { Button } from '@/components/ui/button'
import { RotateCwIcon, PencilIcon, PlusIcon, LoaderCircle } from 'lucide-react'
import { ImageGrid } from './image-grid'
import { useAIGenerator } from './context'
import { ScrollArea } from '@/components/ui/scroll-area'
import { useTranslations } from 'next-intl'

export function PreviewMode() {
  const {
    resources,
    isUploading,
    canUpload,
    createDisable,
    aiGenerator,
    handleEditPrompt,
    handleAddToList,
    handleRemoveImage,
  } = useAIGenerator()

  const t = useTranslations('modals.ai-generator-v2')

  return (
    <div className="space-y-4">
      <div className="relative w-full rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
        <ScrollArea className="max-h-[300px] overflow-y-auto scrollbar-hide">
          <p className="text-lg text-gray-600 dark:text-gray-300 mb-4 break-all whitespace-pre-wrap">
            {resources[0]?.prompt || t('generated_image')}
          </p>
        </ScrollArea>

        <ImageGrid images={resources} onRemove={handleRemoveImage} />

        <div className="flex items-end justify-end gap-4 mt-2">
          <Button
            variant="ghost"
            className="flex items-center gap-2 px-6 py-2 border border-gray-200 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800"
            onClick={aiGenerator}
            disabled={createDisable}
            size="sm"
          >
            <RotateCwIcon className="w-4 h-4" />
            {t('regenerate')}
          </Button>
          <Button
            variant="ghost"
            className="flex items-center gap-2 px-6 py-2 border border-gray-200 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800"
            onClick={handleEditPrompt}
            size="sm"
          >
            <PencilIcon className="w-4 h-4" />
            {t('edit_prompt')}
          </Button>

          <Button
            className="flex items-center gap-2 px-6 py-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-lg hover:opacity-90"
            onClick={handleAddToList}
            disabled={createDisable || !canUpload || isUploading}
            size="sm"
          >
            {isUploading ? (
              <LoaderCircle className="w-4 h-4 animate-spin" />
            ) : (
              <PlusIcon className="w-4 h-4" />
            )}
            {t('add_to_list')}
          </Button>
        </div>
      </div>
    </div>
  )
}
